/**
 * Returns the enabled planes for a product, matching the same criteria
 * used by ProductSubscriptionAccordion on the status page.
 *
 * @param {Object} product - A product object from the API with a `planes` map.
 * @returns {Array<[string, Object]>} Entries of [planeType, planeData] that are
 *   enabled and have at least one product_component.
 */
export const getEnabledPlanes = (product) =>
    Object.entries(product?.planes || {}).filter(
        ([, planeData]) => planeData.enabled && planeData.product_components?.length > 0,
    );

export const hasMultiplePlanes = (product) => getEnabledPlanes(product).length >= 2;
